var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomersNav = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8B9095",
  fillRule: "evenodd",
  d: "M40 8v32H9.6v-4.8H12v2.4h25.6V10.4H12v2.4H9.6V8zm-15.2 9.6a4.8 4.8 0 0 1 3.55 8.03 8 8 0 0 1 4.443 6.823l.007.347h-2.4a5.6 5.6 0 0 0-11.192-.307l-.008.307h-2.4a8 8 0 0 1 4.451-7.172A4.76 4.76 0 0 1 20 22.4a4.8 4.8 0 0 1 4.8-4.8m-12 11.2v2.4H8v-2.4zm0-6.08v2.4H8v-2.4zm12-2.72a2.4 2.4 0 1 0 .001 4.801A2.4 2.4 0 0 0 24.8 20m-12-3.2v2.4H8v-2.4z"
})));
export { SvgCustomersNav as ReactComponent };
export default __webpack_public_path__ + "static/media/customers-nav.78918848.svg";